import { addDays, format, isBefore, startOfDay } from 'date-fns';

export function toTimelessDateString(date: Date): string;
export function toTimelessDateString(date: null | undefined): null;
export function toTimelessDateString(date?: Date | null): string | null;
export function toTimelessDateString(date?: Date | null): string | null {
	if (!date) {
		return null;
	}
	return format(date, 'yyyy-MM-dd');
}

export const dateIsBeforeToday = (date: Date) => {
	return isBefore(startOfDay(date), startOfDay(new Date()));
};

export const dateIsBeforeTomorrow = (date: Date) => {
	return isBefore(startOfDay(date), startOfDay(addDays(new Date(), 1)));
};

// NOTE month is in format MM-YYYY (03-2025 is March 2025)
// and we want to convert it to a date object
export const convertMonthToDate = (monthYear: string) => {
	const [monthPart, yearPart] = monthYear.split('-');
	const year = parseInt(yearPart);
	const month = parseInt(monthPart);
	return new Date(year, month - 1, 1);
};
